import { MutableRefObject, useEffect, useRef } from 'react';

/**
 * Provides execution of callback function on click.
 * If target element match stored in 'ref' - call callback with 'true' parameters, otherwise - with 'false.
 * In case 'ref' is not passed - use current ref (ref of currently rendered component)
 * @param callBack
 * @param ref
 */
function useClick(
    callBack: (isClickOnRef: boolean, event: MouseEvent) => void,
    ref?: MutableRefObject<HTMLElement>,
    ) {
    const componentRef = ref || useRef(null);

    // needed as callBack function might be changed between component's re-renders
    const callbackClosure = callBack;

    useEffect(() => {
        function handleClick(event: MouseEvent) {
            if (!componentRef.current || !componentRef.current.contains(event.target)) {
                // if referenced element is not in dom or click happens outside of this element
                callbackClosure(false, event);
            } else {
                // click targeting element, stored in 'componentRef'
                callbackClosure(true, event);
            }
        }

        document.addEventListener('mousedown', handleClick);

        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClick);
        };
    }, [componentRef, callBack]);
    return componentRef;
}

export { useClick };